/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import rest from '../../../client/js/lib/rest'

export function postResetPassword (data) {
  return rest.post('/api/user/password/reset', {
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(data)
  }).then((resp) => resp.json())
}

export function postUpdatePassword (data) {
  return rest.post('/api/user/password/update', {
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(data)
  }).then((resp) => resp.json())
}
